<template>

  <v-app>

    <v-app-bar
      v-if    = "ui.layout.header.visible"
      app
      flat
      class   = "dense px-6"
      height  = "56px"
    >
      <Header></Header>
    </v-app-bar>

    <v-main class="px-6">
      <router-view />
    </v-main>

  </v-app>

</template>

<script lang="js">

// #region Imports

/* Vuex */
import { mapState } from 'vuex';

/* Telestream */
import Header from './components/header/Header';
import { ConnectionService } from '@/services/connection.service';
import { FETCH_USER_INFO } from '@/utils/action-types'; 
import { SET_EXPERIMENTAL_FEATURES } from './utils/mutation-types';

// #endregion Imports

export default {

  // #region Properties

  name:       'GridFrame',
  components: {
    Header
  },
  computed: {
    ...mapState([
      'ui'
    ])
  },

  // #endregion Properties

  // #region Life-Cycle

  mounted() {
    this.$store.dispatch(FETCH_USER_INFO);
    this.checkExperimentalFeatures();
    this.hideGlobalScrollbar();
  },

  destroyed() {
    this.allowGlobalScrollbar();
  },

  // #endregion Life-Cycle

  // #region Operations

  methods: {
    
    async checkExperimentalFeatures() {
      const connection = ConnectionService.getConnection('/experimental-features');
      await connection.start();
      try {
        const features = await connection.invoke('GetFeatures');
        this.$store.commit(SET_EXPERIMENTAL_FEATURES, features);
      }
      finally {
        await connection.stop();
      }
    },

    hideGlobalScrollbar() {
      let htmlElement = document.getElementsByTagName('html')[0];
      htmlElement.style.overflowY = 'hidden';
      htmlElement.scrollTop = 0;
    },

    allowGlobalScrollbar() {
      let htmlElement = document.getElementsByTagName('html')[0];
      htmlElement.style.overflowY = null;
    }

  }

  // #endregion Operations

}

</script>

<style lang="scss">

  // We will manage this ourselves.
  .dense.v-app-bar .v-toolbar__content {
    padding:          0px;
  }

</style>